import api from '../api';

import CrmSyncActions from 'actions/crm/CrmSyncActions';

/** CrmSyncContactsAndLeadsPrefixSearchSource implements interactions with contacts-and-leads-prefix-search endpoints */
const CrmSyncContactsAndLeadsPrefixSearchSource = {
  searchPrefix: {
    remote(state, prefix, contactAccountId = null) {
      const config = {baseURL: '/apiv2/crm'};
      const data = {prefix: prefix};
      if (contactAccountId !== null) {
        data.account = contactAccountId;
      }
      return api.post(`/search_contacts_and_leads`, data, config);
    },
    loading: CrmSyncActions.prefixSearchContactsAndLeadsLoading,
    success: CrmSyncActions.prefixSearchContactsAndLeadsSuccess,
    error: CrmSyncActions.prefixSearchContactsAndLeadsError,
  },
};

export default CrmSyncContactsAndLeadsPrefixSearchSource;
